<template>
  <div>
    <div class="d-flex flex-row-column justify-content-between">
      <headnavigation :flow="getFlow" />
      <span class="d-flex flex-row-column">
        <span class="input-width-160 r-width-100 d-inline-block mr-3">
          <md-field>
            <label for="filter">{{ $t('agent_specific.filter_by_agent') }}</label>
            <md-select
              v-on:input="filterResults($event,'agent_id')"
              name="filter"
              id="filter"
              v-model="agent_id"
            >
              <md-option value>Show All</md-option>
              <md-option v-for="(item, index) in agents" :key="index" :value="item.id">{{item.name}}</md-option>
            </md-select>
          </md-field>
        </span>
        <span class="input-width-160 r-width-100 d-inline-block mr-3">
          <md-field>
            <label for="filter">Filter by status</label>
            <md-select
              v-on:input="filterResults($event,'status')"
              name="filter"
              id="filter"
              v-model="status"
            >
              <md-option value>Show All</md-option>
              <md-option value="1">Only Active</md-option>
              <md-option value="0">Only Inactive</md-option>
            </md-select>
          </md-field>
        </span>
        <span class="input-width-160 r-width-100 d-inline-block">
          <md-field>
            <label>Search</label>
            <md-input v-on:keyup="search" v-model="search_term"></md-input>
            <md-icon>search</md-icon>
          </md-field>
        </span>
      </span>
    </div>
    <hr class="hr-line" />
    <md-table
      v-if="items.length>0"
      :md-sort-fn="orderBy"
       v-show="!loading"
      v-model="items"
      :md-sort.sync="currentSort"
      :md-sort-order.sync="currentSortOrder"
    >
      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell :md-label="$t('general.agent_id')" md-sort-by="agent_id">{{ item.agent_id }}</md-table-cell>
        <md-table-cell :md-label="$t('general.agent_name')" md-sort-by="agent_name">
          <router-link :to="'/lmt/agents/'+item.id">{{ item.agent_name }}</router-link>
        </md-table-cell>
        <md-table-cell md-label="Complete CTR" md-sort-by="complete">{{ item.complete }}</md-table-cell>
        <md-table-cell md-label="Incomplete CTR" md-sort-by="incomplete">{{ item.incomplete }}</md-table-cell>
        <md-table-cell md-label="Details">
          <router-link
            :to="'/lmt/ctr/agent?agent_id='+item.id"
          >See Details</router-link>
        </md-table-cell>
      </md-table-row>
    </md-table>

    <pagination
      v-on:change="paginationChange($event)"
      v-on:change_per_page="changePerPage($event)"
      v-if="items.length>0&&pagination"
      :meta="pagination.data.meta"
      :links="pagination.data.links"
      :per_page="per_page"
    />

    <empty-state v-if="!loading&&items.length==0" />

    <loading v-if="loading" />

    <confirm type="user" v-if="confirm" @cancel="onCancel" @confirm="onConfirm" />
  </div>
</template>
<script>
// import pagination methods paginationChange and changePerPage
import Pagination from "../../../mixins/pagination.js";

// import CRUD methods for users
import Users from "../../../mixins/users.js";

// Confirmation component before deleting user
import ConfirmDelete from "../../../components/owner/ConfirmDelete";

// mixin for loading data and state
import DataMixin from "../../../mixins/data.js";

export default {
  mixins: [Pagination, Users, DataMixin],
  components: {
    confirm: ConfirmDelete
  },
  data() {
    return {
      status: 1,
      agents: [],
      agent_id: "",
      search_term: "",
      // url for loading data
      api_url: "lmt/ctrs",
      //IMPORTANT loaded data is stored in items
      items: [],
      flow: [{ text: "CTRs" }]
    };
  },
  created() {
    this.loadData();
    
    axios
      .get("/report/agents-dropdown")
      .then(({ data }) => {
        this.agents = data.agents;
      })
      .catch(error => {
        this.loading = false;
      });
  },
  computed: {
    getFlow() {
      let tmp = this.flow;

      return tmp;
    }
  }
};
</script>